import Reveal from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";

export default function ContactSection() {
  return (
    <section id="contact" className="relative py-28 md:py-40 bg-paper border-t border-[rgba(169,129,47,0.26)]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16">
        <div>
          <Reveal>
            <p className="eyebrow mb-6">Contact</p>
            <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="contact-heading">
              Start a T.A.L.K.
            </h2>
            <p className="mt-7 text-inkdim leading-relaxed max-w-md text-[15px]" data-testid="contact-microcopy">
              This isn't advice about how to live. It's a conversation that helps you see
              the pattern you've been too close to notice.
            </p>
            <p className="mt-5 text-inkdim/80 text-sm leading-relaxed max-w-md">
              Write a few honest lines. Rajdeep reads every message herself and replies
              within two working days.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.12}>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
